import moment from 'moment-timezone';
import { EVENT_DATE_TIME_FORMAT } from '../constants/date';

export const getEventDateTime = event =>
  moment(`${event.date} ${event.time}`, EVENT_DATE_TIME_FORMAT);
